<template>
  <div class="user-header">
    <div class="info">
      <div class="avatar-box">
        <img class="avatar" :src="avatar" alt="avatar">
        <nuxt-link class="btn-page" :to="`/user/${userId}`">我的主页</nuxt-link>
      </div>
      <div class="details">
        <span class="name">{{ nickname }}</span>
        <span class="desc">{{ userBrief }}</span>
      </div>
    </div>
    <div class="count">
      <div class="count-item">
        <span class="val">{{ followerCnt }}</span>
        <span class="key">粉丝</span>
      </div>
      <div class="count-item">
        <span class="val">{{ followingCnt }}</span>
        <span class="key">关注</span>
      </div>
      <div class="count-item">
        <span class="val">{{ stockCnt }}</span>
        <span class="key">自选股</span>
      </div>
      <div class="count-item">
        <span class="val">{{ postCnt }}</span>
        <span class="key">发表</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import * as userApi from "~/api/user";
import * as api from "~/api/index";

export default {
  computed: {
    ...mapGetters("user", [
      "userId",
      "avatar",
      "userBrief",
      "nickname",
      "followerCnt",
      "followingCnt",
      "postCnt",
      "stockCnt"
    ])
    // ...mapState("user", {
    //   stockNum : state => state.stockNum,
    //   followingNum : state => state.followingNum
    // })
  },
  data() {
    return {
      // stockCnt: 0,
    };
  },
  methods: {
    initData() {
      // this.$axios(userApi.getMyStock({}))
      //   .then((res) => {
      //     this.stockCnt = res.totalCount;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      this.$axios(userApi.getMyPublish({ count: 0 }));
    }
  },
  // watch:{
  //   followingNum(val){
  //     console.log(val)
  //   }
  // },
  mounted() {
    // DEBUG: 测试服环境下增加调用间隔才能保证调用成功
    // DEBUG: 另一次调用在/my/stock
    // console.log(this.folloingNum)
    setTimeout(() => {
      this.initData();
    }, 100);
  }
};
</script>

<style lang="less" scoped>
.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 50px;
  padding-bottom: 24px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.info {
  display: flex;
  align-items: center;
  .avatar-box {
    position: relative;
    &:hover {
      .btn-page {
        opacity: 1;
      }
    }
    .avatar {
      height: 100px;
      width: 100px;
      border-radius: 50%;
      display: block;
    }
    .btn-page {
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      // height: 28px;
      display: block;
      margin-top: 5px;
      font-size: 12px;
      text-align: center;
      // line-height: 28px;
      color: #3278d2;
      opacity: 0;
      // background: #3278d2;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 16px;

    .name {
      font-size: 16px;
      font-weight: bold;
      color: rgba(34, 34, 34, 1);
    }

    .desc {
      max-width: 500px;
      margin-top: 12px;
      font-size: 14px;
      line-height: 1.4;
      overflow: hidden;
      word-break: break-all;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
  }
}

.count {
  display: flex;

  .count-item {
    display: flex;
    flex-direction: column;
    text-align: right;
    margin-left: 80px;

    .val {
      font-size: 20px;
      text-align: center;
      color: #222;
    }

    .key {
      margin-top: 12px;

      font-size: 14px;

      color: #838d97;
    }
  }
}
</style>
